// Data access for the per-client Usage tab. The API exposes usage on the
// tenant route group, so the admin reaches it with the audited act-as header
// (same mechanism as portal impersonation).
import type { ApiClient } from "./api";

/** Mirrors the API's TenantUsageMetrics (apps/api/src/usage.ts). */
export interface TenantUsageMetrics {
  d1StorageBytes: number;
  d1RowsRead: number;
  d1RowsWritten: number;
  d1Queries: number;
  r2StorageBytes: number;
  r2ClassAOperations: number;
  r2ClassBOperations: number;
}

export async function fetchTenantUsage(
  api: ApiClient,
  tenantId: string,
  startDate: Date,
  endDate: Date
): Promise<TenantUsageMetrics> {
  const query = new URLSearchParams({
    startDate: startDate.toISOString(),
    endDate: endDate.toISOString()
  });
  const data = await api.request<{ usage: TenantUsageMetrics }>(
    `/tenant/usage?${query}`,
    { headers: { "x-act-as-tenant": tenantId } }
  );
  return data.usage;
}
